import { Entities } from '@inwink/entities/entities';
import { getEventDetail, getAuthTenantEvent, getParentNames } from '../modules/event/api/eventdetail';
import { getEventEntityDataSource } from "../modules/event/api/index";

export function detail(eventid: string, customerid: string) {
    // retreive parentNames before to get the tenantId
    return getParentNames(eventid).then((result) => {
        // todo refacto
        const queries = [
            getEventDetail(eventid),
            getAuthTenantEvent(eventid, customerid, result.tenantId).then((res) => res, () => null)
        ];
        return Promise.all(queries).then((res) => {
            // add customerId to authenantEvent object
            const authenantEvent = res[1];
            if (authenantEvent) {
                authenantEvent.customerId = customerid;
            }
            return Object.assign({}, res[0], authenantEvent, {
                parentNames: result
            });
        });
    });
}

export function entitytemplate(eventid, entity, includeStaticFields: boolean) {
    if (!eventid) {
        throw new Error("you must provide eventid");
    }

    const ds = getEventEntityDataSource<Entities.IEntityTemplate>(eventid, entity, entity);
    return ds.entitytemplate(includeStaticFields);
}
